<template>
  <v-dialog
      width="800"
      v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <h2 class="primary--text font-weight-bold pt-5 pl-2">{{ $t('display/elevator:overview.snapshot.snapshot-image') }}</h2>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col md="4">
              <v-btn
                  color="primary"
                  outlined
                  :disabled="isSnapLoading || leftSnapshot == 0 || hideLimitMessage"
                  @click="sendSnapshotRequest"
              >{{ $t('display/elevator:overview.snapshot.make-snapshot') }}</v-btn>
            </v-col>
            <v-col v-if="!isSnapLoading && leftSnapshot > 0" md="4" class="mt-2">
              {{ $t('display/elevator:overview.snapshot.left-snapshots', {left: leftSnapshot, maxSnapshot: maxSnapshot}) }}
            </v-col>
            <v-col v-if="isSnapLoading" md="8">
              {{ $t('display/elevator:overview.snapshot.snap-loading')}}
            </v-col>
            <v-col v-if="!isSnapLoading && leftSnapshot === 0 && !hideLimitMessage" md="8" class="mt-2 red--text">
              {{ $t('display/elevator:overview.snapshot.limit-reached')}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8" class="camera-container">
              <v-img
                  :src="image"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import Utils from '@/modules/core/services/utils';
import OptionService from '@/modules/display/services/option-service';
import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: "SnapImage",
  data() {
    return {
      dialog: false,
      leftSnapshot: 0,
      maxSnapshot: 0,
      snapshotCount: '',
      image: '',
      elevator: null,
      isSnapLoading: false,
      snapshotAttempts: 0,
      snapshotTimestamp: null,
      snapshotInterval: null,
      hideLimitMessage: false
    }
  },
  methods: {
    initialization(elevator) {
      this.setDefault();
      this.elevator = elevator;
      OptionService.getSnapshotCount(
          elevator.id,
          (result) => {
            let snapshots = result.data.split(';');
            this.leftSnapshot = snapshots[0] * 1;
            this.maxSnapshot = snapshots[1] * 1;
            this.dialog = true;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:overview.snapshot.count-snapshot-loading')}));
          }
      )
    },
    setDefault() {
      this.leftSnapshot = 0;
      this.maxSnapshot = 0;
      this.snapshotCount = '';
      this.image = '';
      this.elevator = null;
      this.isSnapLoading = false;
      this.snapshotAttempts = 0;
      this.snapshotTimestamp = null;
      this.snapshotInterval = null;
      this.hideLimitMessage = false;
    },
    sendSnapshotRequest() {
      ElevatorService.sendSnapshotRequest(this.elevator.id,
          (response) => {
            this.isSnapLoading = true;
            this.leftSnapshot = response.data;
            this.snapshotTimestamp = new Date().getTime() - 60000; //we also accept images from 10 seconds ago

            if (this.snapshotInterval == null) {
              this.snapshotInterval = setInterval(this.checkRecentImage, 5000);
              this.snapshotAttempts = 0;
            }
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:finish-failure', {name: this.$t('display/elevator:overview.snapshot.snapshot-loading')}));
          }
      )
    },
    checkRecentImage() {
      this.snapshotAttempts = this.snapshotAttempts + 1;

      if (this.snapshotTimestamp == null || this.snapshotAttempts >= 100) {
        clearInterval(this.snapshotInterval);
        this.snapshotInterval = null;
        return;
      }

      ElevatorService.getRecentImage(
          this.elevator.id,
          this.snapshotTimestamp,
          (response) => {
            if (response.data == null || response.data === "") {
              return;
            }
            this.image = 'data:image/png;base64,' + response.data;

            clearInterval(this.snapshotInterval);
            this.snapshotTimestamp = null;
            this.snapshotInterval = null;
            this.isSnapLoading = false;
            this.hideLimitMessage = true;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:overview.snapshot.snapshot-image')}));
          }
      )
    }
  }
}
</script>

<style scoped>
.camera-container {
  min-height: 600px;
}

</style>
